import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faSpinnerThird } from '@fortawesome/sharp-duotone-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { twMerge } from 'tailwind-merge';

interface ILoaderProps {
  className?: string;
  color?: 'white' | 'secondary' | 'black' | 'pink' | 'purple' | 'blue' | 'success' | 'warning' | 'error'
}

const Loader = ({ className, color}: ILoaderProps) => {
  return (
    <FontAwesomeIcon icon={faSpinnerThird as IconProp} className={twMerge('animate-spin h-5 w-5', className, `${color ? `text-[${color}]` : ``} [&_path.fa-primary]:opacity-80 [&_path.fa-secondary]:opacity-20`)} />
  );
}
export default Loader
